import dotenv from "dotenv";
dotenv.config();

let config = {};

config.api_url = process.env.REACT_APP_AUTH_API;

export { config };
